import { getTenantById } from 'tenants';
import { shouldIncludeLocaleInUrl } from 'utils/locale/get-localized-url';
import { useLocale } from './use-locale';
import { useTenantId } from './use-tenant-id';

export function useLinkLocaleSetting(): string | false {
  const tenantId = useTenantId();
  const tenant = getTenantById(tenantId);
  const { currentLocale } = useLocale(tenantId);
  
  // If locale persistence is disabled, don't add locale to URLs
  if (!tenant.localization?.persistLocalePreference) {
    return false;
  }
  
  return shouldIncludeLocaleInUrl({ locale: currentLocale, tenantId }) 
    ? currentLocale 
    : false;
}
